import {
  artsCareers,
  commerceCareers,
  designCareers,
  engineeringCareers,
  medicalCareers,
  pharmacyCareers,
} from './careerData';

export const careerStreamGuides = [
  {
    id: 'engineering',
    title: 'Engineering & Technology',
    shortTitle: 'Engineering',
    icon: '⚙️',
    gradient: engineeringCareers.gradient,
    data: engineeringCareers,
    summary: 'For students who enjoy maths, building things, coding, and solving real-world problems.',
    whoItFits: ['Maths and science lovers', 'Problem solvers', 'Students curious about coding or machines', 'Anyone who wants flexible tech careers'],
    studyFocus: ['Physics', 'Maths', 'Chemistry', 'Computer Science', 'Electronics'],
    careers: ['Software Engineer', 'AI / ML Engineer', 'DevOps / Cloud Engineer', 'Circuit Engineer', 'Mechanical Engineer', 'Civil Engineer'],
    languages: ['Python', 'C++', 'Java', 'JavaScript', 'SQL', 'Verilog'],
    tools: ['Git & GitHub', 'Linux', 'Docker', 'AutoCAD', 'MATLAB', 'Figma basics'],
    collegeLabels: ['IIT', 'NIT', 'IIIT', 'BITS', 'Govt College', 'Private University'],
    nextSteps: ['Choose PCM in 11th', 'Start basic coding and logic building', 'Prepare for JEE and state CETs', 'Build projects, internships, and a strong portfolio'],
    after12thPath: '/after-12th/pcm',
    highlightPath: '/after-12th/pcm/software-engineer',
  },
  {
    id: 'medical',
    title: 'Medical & Healthcare',
    shortTitle: 'Medical',
    icon: '🏥',
    gradient: medicalCareers.gradient,
    data: medicalCareers,
    summary: 'For students who want patient care, biology, public health, and a strong service-based career.',
    whoItFits: ['Biology-focused students', 'People who like helping others', 'Students comfortable with long study years', 'Those aiming for stable, respected careers'],
    studyFocus: ['Biology', 'Chemistry', 'Physics', 'Anatomy', 'Physiology'],
    careers: ['MBBS Doctor', 'Dentist', 'B.Sc Nursing', 'Lab Technologist', 'Veterinary Doctor', 'Public Health Professional'],
    languages: [],
    tools: ['Dissection labs', 'Clinical practice', 'Medical terminology', 'Research methods'],
    collegeLabels: ['AIIMS', 'JIPMER', 'CMC', 'Govt Medical College', 'Private Medical College'],
    nextSteps: ['Choose PCB in 11th', 'Prepare for NEET early', 'Focus on NCERT and mock tests', 'Plan MBBS or allied-health specializations'],
    after12thPath: '/after-12th/pcb',
    highlightPath: '/after-12th/pcb/mbbs-doctor',
  },
  {
    id: 'pharmacy',
    title: 'Pharmacy',
    shortTitle: 'Pharmacy',
    icon: '💊',
    gradient: pharmacyCareers.gradient,
    data: pharmacyCareers,
    summary: 'For students interested in medicines, drug development, healthcare, and industry roles.',
    whoItFits: ['Students who like chemistry and biology', 'Those curious about medicines', 'People interested in hospital or industry work', 'Students who want global career options'],
    studyFocus: ['Chemistry', 'Biology', 'Pharmacology', 'Medicinal Chemistry', 'Quality Control'],
    careers: ['B.Pharm Pharmacist', 'Clinical Pharmacist', 'Drug Inspector', 'QC Officer', 'Pharma R&D Scientist'],
    languages: [],
    tools: ['Lab testing', 'GMP basics', 'HPLC/analytical instruments', 'Regulatory knowledge'],
    collegeLabels: ['Jamia Hamdard', 'BITS', 'ICT Mumbai', 'JSS', 'Manipal Pharmacy', 'Govt Pharmacy College'],
    nextSteps: ['Choose PCM or PCB in 11th', 'Focus on chemistry and lab skills', 'Prepare for pharmacy entrances', 'Aim for B.Pharm/Pharm.D and internships'],
    after12thPath: '/after-12th/pcb',
    highlightPath: '/after-12th/pcb/pharmacist',
  },
  {
    id: 'commerce',
    title: 'Commerce & Finance',
    shortTitle: 'Commerce',
    icon: '📈',
    gradient: commerceCareers.gradient,
    data: commerceCareers,
    summary: 'For students interested in money, markets, business, accounts, and leadership roles.',
    whoItFits: ['Students who like accounts and economics', 'Business-minded learners', 'Those who want CA, BBA, MBA, or finance careers', 'Future entrepreneurs'],
    studyFocus: ['Accountancy', 'Economics', 'Business Studies', 'Mathematics', 'Finance'],
    careers: ['Chartered Accountant', 'Investment Banker', 'CMA', 'CS', 'BBA / MBA', 'Economist'],
    languages: [],
    tools: ['MS Excel', 'Tally', 'Power BI', 'GST software', 'Financial modeling'],
    collegeLabels: ['SRCC', 'LSR', 'Christ University', 'NMIMS', 'IIM Indore (IPM)', 'Symbiosis'],
    nextSteps: ['Choose Commerce in 11th', 'Keep Maths if finance interests you', 'Plan CA / BBA / economics path early', 'Build presentation and communication skills'],
    after12thPath: '/after-12th/commerce-12',
    highlightPath: '/after-12th/commerce-12/chartered-accountant',
  },
  {
    id: 'arts',
    title: 'Arts & Law',
    shortTitle: 'Arts',
    icon: '⚖️',
    gradient: artsCareers.gradient,
    data: artsCareers,
    summary: 'For students who like reading, writing, debating, law, policy, creative fields, and civil services.',
    whoItFits: ['Strong readers and writers', 'Students good at communication', 'Those interested in law or UPSC', 'Creative and socially aware learners'],
    studyFocus: ['History', 'Political Science', 'Geography', 'Psychology', 'Current Affairs'],
    careers: ['Lawyer', 'IAS / IPS Officer', 'Journalist', 'Psychologist', 'Hotel Manager', 'Designer'],
    languages: [],
    tools: ['Essay writing', 'Debate skills', 'Research and analysis', 'Newspaper reading'],
    collegeLabels: ['NLU', 'NLSIU', 'NALSAR', 'NUJS', 'IIMC', 'Govt College'],
    nextSteps: ['Choose Arts or any stream after 10th', 'Read newspapers daily', 'Target CLAT or UPSC depending on goal', 'Build communication and research skills'],
    after12thPath: '/after-12th/arts-12',
    highlightPath: '/after-12th/arts-12/lawyer',
  },
  {
    id: 'design',
    title: 'Design & Animation',
    shortTitle: 'Design',
    icon: '🎨',
    gradient: designCareers.gradient,
    data: designCareers,
    summary: 'For students who love sketching, visuals, creativity, animation, and digital product experiences.',
    whoItFits: ['Creative thinkers', 'Students who like drawing and visuals', 'Those interested in animation or UI/UX', 'People who want portfolio-based careers'],
    studyFocus: ['Drawing', 'Design Thinking', 'Color Theory', 'Storytelling', 'Digital Tools'],
    careers: ['Fashion Designer', 'UI/UX Designer', 'Animator', 'VFX Artist', 'Product Designer', 'Interior Designer'],
    languages: [],
    tools: ['Figma', 'Photoshop', 'Illustrator', 'Blender', 'After Effects', 'Premiere Pro'],
    collegeLabels: ['NID', 'NIFT', 'UCEED', 'IIT IDC', 'Pearl Academy', 'Design School'],
    nextSteps: ['Build a sketchbook and portfolio', 'Learn digital design tools early', 'Prepare for NID/NIFT/UCEED', 'Practice projects and concept presentations'],
    after12thPath: '/after-12th/arts-12',
    highlightPath: '/after-12th/arts-12/fashion-designer',
  },
];

export const careerStreamGuideMap = Object.fromEntries(
  careerStreamGuides.map((guide) => [guide.id, guide]),
);
